import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import form from './form';
import UserService from '../../services/user-service';
import { isRequired, isValidUser } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import {
  CHANGES_SUCCESSFULL,
  CREATED_USER,
  BEFORE_CREATED,
  EXIST_RUT
} from '../../libraries/texts';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = UserService;
  const {
    match: {
      params: { id }
    }
  } = props;

  const getErrors = values => {
    const errors = {};
    const minimumValues = {
      username: values.username,
      name: values.name,
      lastName: values.lastName,
      role: values.role,
      rut: values.rut
    };
    if (!id || values.password || values.confirmPassword) {
      minimumValues.password = values.password;
      minimumValues.confirmPassword = values.confirmPassword;
    }
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    isValidUser(errors, newValues);
    return errors;
  };

  const wrapperInformation = newValues => {
    const finalValues = {
      ...newValues,
      role: newValues.role.code,
      rut: `${newValues.rut}-${newValues.rutNumber}`
    };
    if (id) {
      if (!finalValues.password || !finalValues.confirmPassword) {
        delete finalValues.password;
        delete finalValues.confirmPassword;
      }
    }
    return finalValues;
  };

  const initialWrapperData = values => {
    const newValues = { ...values };

    if (id) {
      [newValues.rut, newValues.rutNumber] = newValues.rut ? newValues.rut.split('-') : ['', ''];
      newValues.password = '';
      newValues.confirmPassword = '';
    }
    return newValues;
  };

  const errorWrapper = props => err => {
    const { setFieldError } = props;
    if (err.includes(EXIST_RUT)) {
      setFieldError('rut', BEFORE_CREATED);
    }
  };

  return {
    props,
    getErrors,
    wrapperInformation,
    errorWrapper,
    initialWrapperData,
    finalMessageAfterRequest: id ? CHANGES_SUCCESSFULL : CREATED_USER,
    service,
    keyName: 'code'
  };
};

export default withStyles(styles)(EditForm(Edit)(form));
